<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="pi_date"
          :label="customLabel.pi_date || '单据日期'"
          v-model="form.main.pi_date"
        />
        <div class="weui-cell" slot="pi_iocode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_iocode || "售后维修单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.pi_iocode"
              placeholder="请输入"
            />
          </div>
        </div>
        <product-field
          slot="pr_code"
          :label="customLabel.pr_code || '产品编号'"
          v-model="form.main.pr_code"
          @select="onSelectGoods"
        />
        <div class="weui-cell" slot="pr_detail">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pr_detail || "产品名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.pr_detail }}</span>
          </div>
        </div>
        <department-field
          slot="pi_departmentname"
          :label="customLabel.pi_departmentname || '部门名称'"
          v-model="form.main.pi_departmentname"
          @select="onSelectDepartment"
        />
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="pd_prodcode"
              :label="customLabel.pd_prodcode || '物料编号'"
              v-model="item.pd_prodcode"
              @select="onSelectProduct($event, item)"
            />
            <div class="weui-cell" slot="pr_detail">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_detail || "产品名称"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_detail }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_orispeccode }}
              </div>
            </div>
            <div class="weui-cell" slot="pd_outqty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_outqty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pd_outqty"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_unit"
              slot="pr_unit"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_unit || "单位"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.productDTO.pr_unit }}</div>
            </div>

            <div class="weui-cell" slot="pd_qty_extra">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_qty_extra || "辅助数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <span>
                  {{ item.pd_qty_extra }}
                </span>
              </div>
            </div>
            <warehouse-field
              slot="pd_whname"
              v-model="item.pd_whname"
              @select="onSelectWarehouse($event, item)"
              :label="customLabel.pd_whname || '仓库'"
            />
            <div class="weui-cell" slot="pd_batchcode">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_batchcode || "批次号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pd_batchcode"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field
              slot="pd_madetime"
              :label="customLabel.pd_madetime || '生产日期'"
              v-model="item.pd_madetime"
            />
            <div class="weui-cell" slot="pd_shelflife">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_shelflife || "保质期(天)"
                }}</label>
              </div>

              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  @input="onExpireInput(item)"
                  v-model="item.pd_shelflife"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_describe">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_describe || "保质期"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <span>{{ item.srd_describe }}</span>
              </div>
            </div>

            <div class="weui-cell" slot="pd_price">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_price || "成本单价(元)"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pd_price }}
              </div>
            </div>
            <div class="weui-cell" slot="pd_total">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_total || "金额(元)"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pd_total }}
              </div>
            </div>
            <div class="weui-cell" slot="pd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pd_remark"
                  placeholder="请填写"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ProductField from "@/components/field/ProductField.vue";
import DateField from "@/components/field/DateField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    ProductField,
    DateField,
    DepartmentField,
    WarehouseField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "AfterSalePick",
      xtype: "sale-afterSalePick-formpanel",
      form: {
        main: {
          pi_class: "AFTERSALEPICK",
          pi_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
        },
        items: [
          {
            pd_prodid: null,
            pd_prodcode: null,
            srd_describe: null,
            productDTO: {
              pr_detail: null,
              pr_orispeccode: null,
              pr_spec: null,
              pr_unit: null,
            },
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        form = me.$route.params.form;
      if (form) {
        var data = me.$route.params.form.main,
          main = me.form.main;
        main.pi_iocode = data.sr_code;
      }
    },
    /**
     * 选择产品编号
     */
    onSelectGoods(selection) {
      var me = this,
        main = me.form.main;
      main.pr_code = selection.pr_code;
      main.pi_prodid = selection.id;
      main.pr_detail = selection.pr_detail;
    },
    /**
     * 选择物料编号
     */
    onSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO.pr_detail = selection.pr_detail;
      item.productDTO.pr_spec = selection.pr_spec;
      item.productDTO.pr_orispeccode = selection.pr_orispeccode;
      item.productDTO.pr_unit = selection.pr_unit;
    },
    onExpireInput(item) {
      let days = Number(item.pd_shelflife);
      if (days == 0) {
         item.srd_describe = null
      } else {
        let days = Number(item.pd_shelflife);
        item.srd_describe = this.getEndTime(item.pd_madetime, days);
      }
    },
    getEndTime(startTime, days) {
      let manufactureDate = startTime,
        nDate = new Date(manufactureDate),
        time = Math.abs(nDate) + days * 24 * 60 * 60 * 1000,
        rDate = new Date(time);
      if (nDate != null && days != null) {
        let year = rDate.getFullYear();
        let month = rDate.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let date = rDate.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        let result = year + "-" + month + "-" + date;
        return result;
      }
    },
    /**
     * 选择仓库
     */
    onSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 选择部门
     */
    onSelectDepartment(selection) {
      var main = this.form.main;
      main.pi_departmentcode = selection.dp_code;
      main.pi_departmentname = selection.dp_name;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        items = me.form.items,
        checked,
        main = me.form.main;
      var count = 0;

      if (!main.pi_date) {
        me.$weui.topTips("请选择单据日期", 2000);
      } else if (!main.pr_code) {
        me.$weui.topTips("请选择产品编号", 2000);
      } else if (!main.pi_departmentname) {
        me.$weui.topTips("请选择部门名称", 2000);
      } else {
        items.forEach(function (item) {
          if (!item.pd_prodcode) {
            me.$weui.topTips(`第${count + 1}行物料编号未选择`, 2000);
            return false;
          } else if (!item.pd_outqty) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else if (!item.pd_whname) {
            me.$weui.topTips(`第${count + 1}行仓库未选择`, 2000);
            return false;
          } else {
            count++;
            item.pd_pdno = count;
          }
        });
      }
      checked = count == items.length;
      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        ad_qty: 0,
        productDTO: {},
      });
    },
  },
};
</script>